import React, { FC } from 'react';
import { Category, DemandArea } from '../../../../lib/types/endUser';
import { Button } from 'antd';
import styles from './index.module.scss';
import { parseJSON, sortCategoriesByPriority } from '../../../../lib/utils/helpers';
import cn from 'classnames';
import { checkBoughtProductsInCategory } from '../../../../lib/utils/end-user-helpers';
import { CampaignObjectImage } from '../../../CampaignObjectImage';
import { IconComponent } from '../../../IconComponent';
import { EndUserTypography } from '../../../EndUserTypography';

import HouseTopLeftFrame from '../../../../assets/images/evi-house-left-angle.png';
import HouseTopRightFrame from '../../../../assets/images/evi-house-right-angle.png';
import HouseLogo from '../../../../assets/images/evi-house-logo.png';

type Props = {
  demandAreas?: DemandArea[];
  handleAreaClick?: any;
  handleKeyDown?: any;
  handleCategoryClick?: (areaId: number, category: Category) => void;
  showButton?: boolean;
  buttonColor?: string;
  buttonText?: string;
  fillAllCategories?: boolean;
  //
  handleKeyDownCategory?: (
    event: React.KeyboardEvent<HTMLDivElement>,
    category: Category,
  ) => void;
  onClickCategory?: (category: Category) => void;
  activeId?: number;
};

export const EviNewHouseModelDesktop: FC<Props> = ({
  demandAreas,
  handleAreaClick,
  handleKeyDown,
  handleCategoryClick,
  showButton,
  buttonColor,
  buttonText,
  fillAllCategories,
  //
  handleKeyDownCategory,
  onClickCategory,
  activeId,
}) => {
  return (
    <>
      {showButton && (
        <Button
          style={{
            backgroundColor: `linear-gradient(180deg, ${buttonColor} 0%, #007829 100%)`,
          }}
          className={styles.circleButton}
        >
          {buttonText}
        </Button>
      )}
      <div className={styles.container}>
        <img src={HouseLogo} alt="logo" className={styles.logo} />

        <div className={styles.innerContainer}>
          <div className={styles.houseTop}>
            {demandAreas?.slice(0, 2).map((area, index) => {
              const isLeft = index === 0;
              // const areaColor = parseJSON(area.color);
              const sortedCategories = sortCategoriesByPriority(area.categories);

              const hideAll = activeId && area.id !== activeId;

              return (
                <div
                  role="presentation"
                  onClick={() => handleAreaClick && handleAreaClick(area.id, area.name)}
                  onKeyDown={(event) => handleKeyDown(event, area.id, area.name)}
                  key={area.id}
                  className={cn(
                    isLeft ? styles.houseTopLeftSide : styles.houseTopRightSide,
                  )}
                >
                  {isLeft && (
                    <img
                      src={HouseTopLeftFrame}
                      className={styles.leftFrame}
                      alt="frame"
                    />
                  )}

                  {!isLeft && (
                    <img
                      src={HouseTopRightFrame}
                      className={styles.rightFrame}
                      alt="frame"
                    />
                  )}

                  <div className={styles.categoriesContainer}>
                    {sortedCategories.map((category) => {
                      const hasUserProducts = fillAllCategories
                        ? fillAllCategories
                        : checkBoughtProductsInCategory(category);

                      return (
                        <div
                          role="presentation"
                          onClick={(e) => {
                            e.stopPropagation();

                            onClickCategory && onClickCategory(category);

                            handleCategoryClick && handleCategoryClick(area.id, category);
                          }}
                          onKeyDown={(event) =>
                            handleKeyDownCategory &&
                            handleKeyDownCategory(event, category)
                          }
                          key={category.id}
                          className={cn(styles.categoryItem)}
                          style={{
                            background: hideAll
                              ? '#6588f3'
                              : hasUserProducts
                                ? `#8dc123`
                                : category.isAddedToWishlist
                                  ? `repeating-linear-gradient(-45deg, #8DC123, #8DC123 5px, rgba(255, 255, 255, 1) 5px, rgba(255, 255, 255, 1) 10px)`
                                  : '#fff',
                          }}
                        >
                          {category.campaignObject ? (
                            <CampaignObjectImage
                              campaignObject={category.campaignObject}
                            />
                          ) : (
                            <IconComponent
                              className={styles.icon}
                              iconData={category?.icon}
                              style={{
                                visibility: hideAll ? 'hidden' : 'visible',
                              }}
                              color={hasUserProducts ? '#fff' : '#243361'}
                            />
                          )}

                          <EndUserTypography
                            type="subText"
                            component="Text"
                            className={styles.title}
                            style={{
                              visibility: hideAll ? 'hidden' : 'visible',
                              color: hasUserProducts ? '#fff' : '#243361',
                              textAlign: 'center',
                              minHeight: '40px',
                            }}
                          >
                            {category.name}
                          </EndUserTypography>
                        </div>
                      );
                    })}
                  </div>
                  <EndUserTypography
                    type="headlineFourth"
                    component="Title"
                    className={styles.areaTitle}
                    style={{
                      color: '#fff',
                      visibility: hideAll ? 'hidden' : 'visible',
                    }}
                  >
                    <span>{area.name}</span>
                    {area.campaignObject && (
                      <CampaignObjectImage
                        campaignObject={area.campaignObject}
                        containerClassName={styles.campaignObjectContainer}
                        imageClassName={styles.campaignImage}
                        completedIconClassName={styles.completedIcon}
                      />
                    )}
                  </EndUserTypography>
                </div>
              );
            })}
          </div>

          <div className={styles.houseBottom}>
            {demandAreas?.slice(2).map((area, index) => {
              const isLeft = index === 0;
              const sortedCategories = sortCategoriesByPriority(area.categories);
              const hideAll = activeId && area.id !== activeId;

              return (
                <div
                  role="presentation"
                  onClick={() => handleAreaClick && handleAreaClick(area.id, area.name)}
                  onKeyDown={(event) => handleKeyDown(event, area.id, area.name)}
                  key={area.id}
                  className={cn(
                    isLeft ? styles.houseBottomLeftSide : styles.houseBottomRightSide,
                  )}
                >
                  <div className={styles.categoriesContainer}>
                    {sortedCategories.map((category) => {
                      const hasUserProducts = fillAllCategories
                        ? fillAllCategories
                        : checkBoughtProductsInCategory(category);

                      return (
                        <div
                          role="presentation"
                          onClick={(e) => {
                            e.stopPropagation();

                            onClickCategory && onClickCategory(category);

                            handleCategoryClick && handleCategoryClick(area.id, category);
                          }}
                          onKeyDown={(event) =>
                            handleKeyDownCategory &&
                            handleKeyDownCategory(event, category)
                          }
                          key={category.id}
                          className={cn(styles.categoryItemBottom)}
                          style={{
                            background: hideAll
                              ? '#6588f3'
                              : hasUserProducts
                                ? `#8dc123`
                                : category.isAddedToWishlist
                                  ? `repeating-linear-gradient(-45deg, #8DC123, #8DC123 5px, rgba(255, 255, 255, 1) 5px, rgba(255, 255, 255, 1) 10px)`
                                  : '#fff',
                          }}
                        >
                          {category.campaignObject ? (
                            <CampaignObjectImage
                              campaignObject={category.campaignObject}
                            />
                          ) : (
                            <IconComponent
                              className={styles.icon}
                              iconData={category?.icon}
                              style={{ visibility: hideAll ? 'hidden' : 'visible' }}
                              color={hasUserProducts ? '#fff' : '#243361'}
                            />
                          )}

                          <EndUserTypography
                            type="subText"
                            component="Text"
                            className={styles.title}
                            style={{
                              visibility: hideAll ? 'hidden' : 'visible',
                              color: hasUserProducts ? '#fff' : '#243361',
                              textAlign: 'center',
                              minHeight: '40px',
                            }}
                          >
                            {category.name}
                          </EndUserTypography>
                        </div>
                      );
                    })}
                  </div>

                  <EndUserTypography
                    type="headlineFourth"
                    component="Title"
                    className={styles.areaTitle}
                    style={{
                      color: '#fff',
                      visibility: hideAll ? 'hidden' : 'visible',
                    }}
                  >
                    <span>{area.name}</span>

                    {area.campaignObject && (
                      <CampaignObjectImage
                        campaignObject={area.campaignObject}
                        containerClassName={styles.campaignObjectContainer}
                        imageClassName={styles.campaignImage}
                        completedIconClassName={styles.completedIcon}
                      />
                    )}
                  </EndUserTypography>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </>
  );
};
